module.exports = __webpack_public_path__ + "img/arrow-redirect.2668b96c.svg";